module.exports = __webpack_public_path__ + "b6dd8d584fb0504cde457263b87f4f13.pdf";